
import React from "react";
import { Button } from "@/components/ui/button";
import RichContentRenderer from "../RichContentRenderer";
import { KnowledgeArticle } from "./types";

interface KnowledgeArticleViewProps {
  article: KnowledgeArticle | null;
  onBack?: () => void;
  isEmbedded?: boolean;
}

const KnowledgeArticleView = ({
  article,
  onBack,
  isEmbedded = false
}: KnowledgeArticleViewProps) => {
  if (!article) {
    return (
      <div className="flex flex-col items-center justify-center h-64 text-center">
        <p className="text-muted-foreground">
          Select an article to view its content
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {isEmbedded && onBack && (
        <div className="flex items-center">
          <Button 
            variant="outline" 
            size="sm" 
            onClick={onBack}
            className="mb-2"
          >
            Back to articles
          </Button>
        </div>
      )}
      <div className={`prose ${isEmbedded ? 'prose-sm' : 'prose-sm md:prose-base'} max-w-none`}>
        <h1 className={`${isEmbedded ? 'text-xl' : 'text-2xl'} font-bold mb-${isEmbedded ? '3' : '6'}`}>
          {article.title}
        </h1>
        <RichContentRenderer 
          content={article.content} 
          className="prose prose-headings:font-bold prose-headings:tracking-tight prose-a:text-primary prose-a:underline hover:prose-a:text-primary/80"
        />
      </div>
    </div>
  );
};

export default KnowledgeArticleView;
